<template>
  <Modal id="deleteUserModal" data-bs-backdrop="static">
    <template #header>
      <h5 class="modal-title">{{ $t('key_modalConfirmDeleteAction_delete') }}</h5>
    </template>
    <template #body>
      <div class="row">
        <p>
          {{ $t('key_filemodalselector_delete_confirmation') }}
        </p>
      </div>
    </template>
    <template #footer>
      <button ref="closeButton" type="button" class="btn btn-outline-primary d-none" data-bs-dismiss="modal" />
      <button ref="cancelButton" type="button" class="btn btn-outline-primary" data-bs-dismiss="modal">
        {{ $t('key_cancel') }}
      </button>
      <button type="button" class="btn bg-gradient-success" @click="confirmDelete">
        {{ $t('key_delete') }}
      </button>
    </template>
  </Modal>
</template>
  
<script>
import Modal from "@/components/ModalHotakauth.vue";
export default {
  components: { Modal },
  props: {
    entity: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['confirm-delete'],
  data() {
    return {};
  },
  computed: {},
  created() {
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.hideModal();
      }
    });
  },
  methods: {
    hideModal() {
      let button = this.$refs.closeButton;
      if (button) button.click()
    },
    confirmDelete() {
      this.$emit('confirm-delete', this.entity);
      this.hideModal();
    },
  },
};
</script>
  
<style lang="scss" scoped>
.modal-usuarios .modal-container {
  width: 550px !important;
}

</style>